import Button from "@shared/v2/Button";
import Typography from "@shared/v2/Typography";
import ArrowUpRightFromSquareSolidV6 from "@shared/v2/Icomoon/Icons/ArrowUpRightFromSquareSolidV6";

const PaymentMethods = ({ portalUrl }: { portalUrl: string }) => (
  <div className="tw-py-[64px] tw-text-center tw-flex tw-flex-col tw-gap-[16px]">
    {/* @ts-expect-error props */}
    <Typography variant="headline3">
      Access your billing information in your
      <br />
      <b>Billing Portal</b>
    </Typography>
    {/* @ts-expect-error props */}
    <Typography className="tw-max-w-[460px] tw-self-center">
      Manage your payment methods, change your add-ons plans, and view your payment history in your
      <b> Billing Portal</b>.
    </Typography>
    {/* @ts-expect-error props */}
    <Button className="tw-self-center" size="medium" onClick={() => window.open(portalUrl, "_blank")}>
      Billing Portal <ArrowUpRightFromSquareSolidV6 />
    </Button>
  </div>
);

export default PaymentMethods;
